import { WhatsappLogo } from '@phosphor-icons/react';

export const WhatsAppConfirmButton = ({ url, variant = 'button', className = '', testId }) => {
  if (!url) return null;
  const stop = (e) => e.stopPropagation();
  if (variant === 'icon') {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" onClick={stop} title="Confirmar por WhatsApp" data-testid={testId}
        className={`inline-flex items-center justify-center w-8 h-8 rounded-full text-[#128C7E] hover:bg-[#25D366]/10 transition-colors ${className}`}>
        <WhatsappLogo size={16} weight="fill" />
      </a>
    );
  }
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" onClick={stop} data-testid={testId}
      className={`inline-flex items-center justify-center gap-2 border border-[#25D366] text-[#128C7E] rounded-full px-4 py-2 text-sm font-medium hover:bg-[#25D366]/10 transition-colors ${className}`}>
      <WhatsappLogo size={16} weight="fill" /> WhatsApp
    </a>
  );
};
